import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
// google-sign-in/US-001 (T1, AC-001.2): configure Amplify for the Cognito
// Hosted-UI Google OAuth door ONCE, before any component (including
// ContinueWithGoogleButton) mounts. Never throws — a missing env var only
// disables the Google button; email/password login is unaffected.
import { configureAmplifyOAuth } from '@/lib/amplifyConfig';
// BUG-20260722-000251 (T-4, RC-004/RC-005): wire React 19's root-level error
// hooks and the global window listeners BEFORE the very first render, so a
// crash during initial mount is still captured. installGlobalErrorHandlers()
// never throws (same fail-safe contract as configureAmplifyOAuth above).
import {
  installGlobalErrorHandlers,
  handleReactUncaughtError,
  handleReactCaughtError,
  handleReactRecoverableError,
} from '@/lib/errorReporter';

configureAmplifyOAuth();
installGlobalErrorHandlers();

createRoot(document.getElementById('root')!, {
  // onUncaughtError: nothing above caught it (metric-eligible).
  onUncaughtError: handleReactUncaughtError,
  // onCaughtError: the ErrorBoundary (App.tsx) DID catch it — this is the
  // single metric-eligible send for a boundary-caught render error (ISS-003);
  // ErrorBoundary.componentDidCatch reports the same error as a log-only
  // event instead, so the ClientError metric increments exactly once.
  onCaughtError: handleReactCaughtError,
  // onRecoverableError: React retried and succeeded — log-only, not a failure.
  onRecoverableError: handleReactRecoverableError,
}).render(
  <StrictMode>
    <App />
  </StrictMode>
);
